import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeService } from '../home/home.service';
import { QuranCalligraphyDto } from '../../shared/models/holy-quran/holy-quran-base.dto';
import { BehaviorSubject, switchMap, tap, map } from 'rxjs';
import { BrowsePaginatorComponent } from '../../features/browse-index/components/browse-paginator/browse-paginator.component';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';
import { PaginationState } from '../../features/browse-index/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-quran-calligraphies',
  standalone: true,
  imports: [CommonModule, BrowsePaginatorComponent, BreadCrump, TranslateModule, RouterLink],
  templateUrl: './quran-calligraphies.html',
  styleUrl: './quran-calligraphies.scss',
})
export class QuranCalligraphiesComponent implements OnInit {
  private apiService = inject(HomeService);
  public translateService = inject(TranslateService);
  public environment = environment;

  private page$ = new BehaviorSubject<number>(1);
  private pageSize = 9;

  calligraphies: QuranCalligraphyDto[] = [];
  loading = signal<boolean>(false)
  pagination: PaginationState = {
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0
  };

  ngOnInit(): void {
    this.page$.pipe(
      tap(() => this.loading.set(true)),
      switchMap(page => this.apiService.getQuranCalligraphiesPaginated(page, this.pageSize))
    ).subscribe((res) => {
      this.calligraphies = res.result || [];
      this.pagination = {
        currentPage: this.page$.value,
        pageSize: this.pageSize,
        totalCount: res.totalElements,
        totalPages: Math.ceil(res.totalElements / this.pageSize) || 0
      };
      this.loading.set(false);
    });
  }

  onPageChange(page: number): void {
    this.page$.next(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
